@if (data$ | async; as component) {
  <div class="info-boxes-container" [style]="'background-color :'+ component.background" [id]="component.styleClasses ? component.styleClasses : ''">
    @switch (component.titleTag) {
      @case ('H1') {
        <h1 class="h2-component title">{{component.title}}</h1>
      }
      @case ('H2') {
        <h2 class="h2-component title">{{component.title}}</h2>
      }
      @default {
        <div class="h2-component title">{{component.title}}</div>
      }
    }
    @if (items$ | async; as components) {
      <div class="info-boxes-list">
        @for (component of components; track component; let i = $index) {
          @if (component) {
            <app-custom-item-info-box [item]="component"></app-custom-item-info-box>
          }
        }
      </div>
    }
    @if (component.text || component.urlButton) {
      <div class="extra-info">
        @if (component.text) {
          <div class="text">{{component.text}}</div>
        }
        @if (component.textButton && component.urlButton) {
          <div class="button">
            <a [routerLink]="component.urlButton">
              {{component.textButton}}
            </a>
          </div>
        }
      </div>
    }
  </div>
}
